import * as primerComponents from '@primer/react'
import * as doctocatComponents from '@primer/gatsby-theme-doctocat'

// eslint-disable-next-line import/no-anonymous-default-export
export default {...primerComponents, ...doctocatComponents}
